import styled from 'styled-components';

export const ImageWrapper = styled.div`
  cursor: grab;
  min-width: 28.5rem;
  @media (${({ theme }) => theme.respondTo.desktop}) {
    min-width: 54rem;
  }
`;
